export const getSelectedLanguage = store => store?.general?.selectedLanguage
